import { createFileRoute } from "@tanstack/react-router";
import { Section, SectionHeader } from "@/components/Section";
import { CTASection } from "@/components/CTASection";
import { Breadcrumbs } from "@/components/Breadcrumbs";
import { Reveal } from "@/components/Reveal";
import { TEAM } from "@/lib/team";
import { SITE } from "@/lib/site";
import { seoTitle, seoDescription } from "@/lib/seo-meta";

const TITLE = seoTitle("Time editorial — Concurso Astor");
const DESC = seoDescription(
  "Conheça o time editorial do Concurso Astor: editores e colaboradores responsáveis pelos artigos sobre gestão, estratégia, finanças, marketing e vendas.",
);

export const Route = createFileRoute("/equipe")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:url", content: "/equipe" },
    ],
    links: [{ rel: "canonical", href: `${SITE.baseUrl}/equipe` }],
  }),
  component: Equipe,
});

function Equipe() {
  return (
    <>
      <section className="hero-bg">
        <div className="container-svg pt-12 pb-12 md:pt-20 md:pb-16">
          <Breadcrumbs items={[{ label: "Início", to: "/" }, { label: "Time editorial" }]} />
          <div className="mt-6 max-w-3xl">
            <span className="eyebrow">Time editorial</span>
            <h1 className="mt-4 text-4xl font-bold tracking-tight md:text-5xl">
              Quem escreve no Concurso Astor
            </h1>
            <p className="mt-5 text-base text-muted-foreground md:text-lg">
              Time multidisciplinar com experiência em gestão, estratégia, finanças, marketing e vendas. Cada artigo é assinado por um responsável identificado e revisado antes da publicação.
            </p>
          </div>
        </div>
      </section>

      <Section>
        <SectionHeader
          eyebrow="O time"
          title="As pessoas por trás dos artigos"
          description="Cada integrante é responsável pela área editorial em que atua."
        />
        <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {TEAM.map((m, i) => (
            <Reveal key={m.name} delay={((i % 4) + 1) as 1 | 2 | 3 | 4}>
              <article className="card-glass flex h-full flex-col items-center text-center">
                {m.photo ? (
                  <img
                    src={m.photo}
                    alt={`Foto de ${m.name}`}
                    loading="lazy"
                    width={96}
                    height={96}
                    className="h-24 w-24 rounded-full object-cover border border-border"
                  />
                ) : (
                  <div aria-hidden className="flex h-24 w-24 items-center justify-center rounded-full text-2xl font-bold text-background bg-foreground">{m.initials}</div>
                )}
                <h3 className="mt-5 text-lg font-semibold">{m.name}</h3>
                <p className="mt-1 text-xs uppercase tracking-wider font-semibold text-foreground">{m.role}</p>
                <p className="mt-3 text-sm text-muted-foreground">{m.bio}</p>
              </article>
            </Reveal>
          ))}
        </div>
      </Section>

      <CTASection title="Leia os artigos do time editorial" text="Conteúdo prático sobre gestão, estratégia, finanças, marketing e vendas — publicado semanalmente." buttonLabel="Ver os artigos" />

    </>
  );
}
